<template>
  <div class="satellites">
    <v-container class="my-5">
      <v-row class="ml-1">
        <v-col cols="12" sm="12" md="4" lg="3" class="mt-1">
          <v-text-field v-model="findTxt" hide-details outlined dense clearable label="Find" prepend-inner-icon="mdi-magnify"></v-text-field>
        </v-col>
        <v-col cols="12" sm="12" md="4" lg="3">
          <v-select v-model="statusSelect" :items="statusItems" label="Status" multiple chips hide-details clearable dense prepend-inner-icon="mdi-filter-menu" :menu-props="{ bottom: true, offsetY: true }">
            <template v-slot:selection="data">
              <v-chip :class="data.item" :key="JSON.stringify(data.item)" v-bind="data.attrs" :input-value="data.selected" @click:close="statusSelect.splice(statusSelect.indexOf(data.item), 1)" close >
                {{ data.item }}
              </v-chip>
            </template>
          </v-select>
        </v-col>
        <v-col cols="12" class="d-none d-md-block" md="4" lg="3">
          <v-select v-model="freqSelect" :items="freqItems" label="Frequency" multiple hide-details chips clearable dense prepend-inner-icon="mdi-filter-menu" :menu-props="{ bottom: true, offsetY: true }">
            <template v-slot:selection="data">
              <v-chip :class="data.item" :key="JSON.stringify(data.item)" v-bind="data.attrs" :input-value="data.selected" @click:close="freqSelect.splice(freqSelect.indexOf(data.item), 1)" close >
                {{ data.item }}
              </v-chip>
            </template>
          </v-select>
        </v-col>
      </v-row>
      <v-layout row wrap>
        <v-flex xs12 sm6 md4 lg3 v-for="sat in satellites" :key="sat.name">
          <v-card class="text-center ma-4 rounded-lg clickable" :to="`satellite/${sat.name}`">
            <v-img height="300" :src="sat.images[0]">
              <template v-slot:placeholder>
                <v-row
                  class="fill-height ma-0"
                  align="center"
                  justify="center"
                >
                  <v-progress-circular
                    indeterminate
                    color="grey"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
            <!--<v-responsive class="pt-4">{{ sat.images[0] }}</v-responsive>-->
            <v-row
              align="center"
              justify="end"
            >
              <v-icon class="mr-1">
                mdi-satellite-variant
              </v-icon>      
              <span class="subheading mr-2">{{sat.confirmedPackets.toLocaleString()}}</span>
              <span class="mr-1">·</span>
              <v-icon class="mr-1">
                mdi-radio-tower
              </v-icon>
              <span class="subheading">{{sat.frames.toLocaleString()}}</span>
            </v-row>   
            <v-card-text style="overflow-y: auto; height:150px">
              <div class="subheading"><strong>{{ sat.displayName }}</strong></div>
              <div class="grey--text">{{ sat.description }}</div>
            </v-card-text>
            <v-card-text>
              <div class="mr-1" v-if="sat.lastPacketTime"><strong>Last Packet</strong> {{ formatLaunchDate(sat.lastPacketTime) }}</div>
              <div class="mt-3" v-if="sat.status=='Future'"><strong>Launch Date:</strong> {{formatLaunchDate(sat.launchDate)}}</div>
            </v-card-text>
            <v-chip v-for="(conf,i) in sat.configurations" :key="i" :class="`${conf.mode} ma-2`">{{conf.mode}}@{{conf.freq}}</v-chip>
            <v-chip :class="`${sat.status} ma-2`">{{sat.status}}</v-chip>
            <v-card-actions>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script setup>
import { ref, computed, onBeforeMount } from 'vue'
import axios from '../plugins/axios'
import moment from 'moment'

// Estado reactivo
const findTxt = ref("")
const statusSelect = ref(['Supported'])
const statusItems = ['Supported', 'Future', 'Experimental', 'Inactive']
const freqSelect = ref([])
const freqItems = ['137','433','868-915','2400']
const origData = ref([])

// Cargar satélites
const getSatellites = async () => {
  const { data } = await axios.get(`/v1/satellites`)
  origData.value = data
}

// Formatear fechas
const formatLaunchDate = (date) => {
  return moment(date).format('MMMM Do YYYY, H:mm:ss ')
}

// Filtro y lógica de listado
const satellites = computed(() => {
  if (!origData.value) return null

  let sats
  if (findTxt.value)
    sats = origData.value.filter(s => 
      s.name.toLowerCase().includes(findTxt.value.toLowerCase()) ||
      s.displayName.toLowerCase().includes(findTxt.value.toLowerCase()) ||
      (s.longDescription && s.longDescription.toLowerCase().includes(findTxt.value.toLowerCase()))
    )
  else
    sats = origData.value

  if (statusSelect.value.length > 0)
    sats = sats.filter(sat => statusSelect.value.includes(sat.status))

  if (freqSelect.value.length > 0) {
    let freqRanges = []
    if (freqSelect.value.includes('137')) freqRanges.push([130, 300])
    if (freqSelect.value.includes('433')) freqRanges.push([400, 550])
    if (freqSelect.value.includes('868-915')) freqRanges.push([800, 950])
    if (freqSelect.value.includes('2400')) freqRanges.push([2100, 2500])

    sats = sats.filter(sat => 
      sat.configurations &&
      sat.configurations.some(conf => 
        freqRanges.some(([min, max]) => conf.freq > min && conf.freq < max)
      )
    )
  }

  return sats
})

// Hook de ciclo de vida
onBeforeMount(getSatellites)
</script>

<style>
.subheading {
  margin: 10px 20px;
}

.Supported {
  background: #4CAF50 !important;
}

.Future {
  background: #82B1FF  !important;
}

.Experimental {
  background: #FFC107  !important;
}

.Inactive {
  background: #FF5252  !important;
}

.clickable:hover {
  top: -5px;
}
</style>